import { useSelector } from "react-redux";
import { useIntercom } from "react-use-intercom";

import Support from "../assets/svg/icons-new/support.svg";

export default function Coms() {
  const { boot } = useIntercom();
  const state = useSelector((state) => state.auth.profile.data);
  // console.log(state, "STATE");
  const { _id, firstName, email, phone, createdAt } = state;

  // console.log(boot, _id, "BOOT");

  // const userData = JSON.parse(localStorage.getItem("btm_user"));

  const bootWithProps = () =>
    boot({
      name: firstName,
      userId: _id,
      email: email,
      phone: phone || undefined,
      createdAt: createdAt,
    });

  return (
    <div onClick={bootWithProps} className="asl-action-single">
      <div className="asl-action-desc">
        <img className="right-m2" src={Support} alt="edit" />
        <p>Support </p>
      </div>
    </div>
  );
}
